import React, { useEffect } from 'react';
import './App.css';
import './css/mainstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import Dashboard from './Pages/Dashboard';
import Login from './Pages/Loginpage';
import UpdateProfile from './Pages/Updateprofile';
import LenderList from './Pages/Lender';
import BorrowerList from './Pages/Borrower';
import ProjectList from './Pages/Projects';
import Projectview from './Pages/Project-view';
import ViewUser from './Pages/Viewuser';
import ProjectStatus from './Pages/Fundproject';
import Privateroute from './components/Privateroute/Privateroute';
import FundSecureList from './Pages/Fundsecure';
import Lenders from './Pages/Lender';
import Borrowers from './Pages/Borrower';
import BackgroundCheck from './Pages/BackgroundCheck';
import Newdeals from './Pages/Newdeals/Newdeals';
import Interesteduser from './Pages/Interesteduser/Interesteduser';
import NewMatches from './Pages/NewMatches';
import DealsMarked from './Pages/DealsMarked';
import MatchingConversion from './Pages/MatchingConversion';
import FreeTrialsList from './Pages/FreeTrials';
import Notifications from './Pages/Notification';
import SendNotification from './Pages/Notification/sendNotification';
import Admin from './Pages/Admin';
import CreateAdmin from './Pages/Admin/CreateAdmin';
import TcPathway from './Pages/TcPathway';
import DealsAssigned from './Pages/DealsAssigned';
import Resources from './Pages/Resources';
import AddResource from './Pages/Resources/AddResource';
import EditResource from './Pages/Resources/EditResource';
import Blogs from './Pages/Blogs';
import AddBlog from './Pages/Blogs/AddBlog';
import EditBlog from './Pages/Blogs/EditBlog';
import ResourceCategory from './Pages/ResourceCategory';
import ManageResource from './Pages/ManageResource';
import CreateUser from './Pages/ManageResource/CreateUser';
import EditUser from './Pages/ManageResource/EditUser';
import CreateCompany from './Pages/ManageResource/CreateCompany';
import EditCompany from './Pages/ManageResource/EditCompany';
import AnalyticsDetail from './Pages/Resources/AnalyticsDetail';
import CreateChecklist from './Pages/ManageResource/CreateChecklist';
import EditChecklist from './Pages/ManageResource/EditChecklist';
import CreateVideo from './Pages/ManageResource/CreateVideo';
import EditVideo from './Pages/ManageResource/EditVideo';
import UserVideos from './Pages/ManageResource/UserVideos';
import CompanyVideos from './Pages/ManageResource/CompanyVideo';
import UserButtons from './Pages/ManageResource/ManageButtons/UserButtons';
import CompanyButtons from './Pages/ManageResource/ManageButtons/CompanyButton';
import CreateUserButtons from './Pages/ManageResource/ManageButtons/CreateUserButton';
import CreateCompanyButtons from './Pages/ManageResource/ManageButtons/CreateCompanyButton';
import LenderRatings from './Pages/LenderRating';
import BorrowerRatings from './Pages/BorrowerRatings';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, 0);
  }, [pathname]);
  return null;
}

function App() {
  const token = window.localStorage.getItem("token");
  // const isLoggedIn = !!token;

  return (
    <>
      <ScrollToTop />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<Privateroute />}>
          <Route path="/update-profile" element={<UpdateProfile />} />
          <Route path="/lender-ratings" element={<LenderRatings />} />
          <Route path="/borrower-ratings" element={<BorrowerRatings />} />
        </Route>

        <Route
          element={
            <Privateroute allowedRoles={["super_admin", "admin", "virtual_assistant"]} />
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/lender" element={<Lenders />} />
          <Route path="/borrower" element={<Borrowers />} />
          <Route path="/background-check" element={<BackgroundCheck />} />
          <Route path="/free-trials" element={<FreeTrialsList />} />
          <Route path="/projects" element={<ProjectList />} />
          <Route path="/view-project/:id" element={<Projectview />} />
          <Route path="/view-user/:id" element={<ViewUser />} />
          <Route path="/fundsecure-list" element={<FundSecureList />} />
          <Route path="/dealsmarked" element={<DealsMarked />} />
          <Route path="/newmatches" element={<NewMatches />} />
          <Route path="/new-project-deals" element={<Newdeals />} />
          <Route path="/interested-user" element={<Interesteduser />} />
          <Route path="/matching-conversion" element={<MatchingConversion />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/create-admin" element={<CreateAdmin />} />
          <Route path="/tc-purchase" element={<TcPathway />} />
          <Route path="/notification" element={<Notifications />} />
          <Route path="/send-notification" element={<SendNotification />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/add-resource" element={<AddResource />} />
          <Route path="/edit-resource/:id" element={<EditResource />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/add-blog" element={<AddBlog />} />
          <Route path="/edit-blog/:id" element={<EditBlog />} />
          <Route path="/manage-resource/:id" element={<ManageResource />} />
          <Route path="/create-user/:id" element={<CreateUser />} />
          <Route path="/resources/:resourceId/edit-user/:userId" element={<EditUser />} />
          <Route path="/create-company/:id" element={<CreateCompany />} />
          <Route path="/resources/:resourceId/edit-company/:companyId" element={<EditCompany />} />
          <Route path="/resource-category" element={<ResourceCategory />} />
          <Route path="/analytics-detail" element={<AnalyticsDetail />} />
          <Route path="/create-checklist/:id" element={<CreateChecklist />} />
          <Route path="/resources/:resourceId/edit-checklist/:checklistId" element={<EditChecklist />} />
          <Route path="/create-video/:id" element={<CreateVideo />} />
          <Route path="/resources/:resourceId/edit-video/:videoId" element={<EditVideo />} />
          <Route path="/create-user-video/:id" element={<UserVideos />} />
          <Route path="/create-company-video/:id" element={<CompanyVideos />} />
          <Route path="/manage-user/:resourceId/button/:id" element={<UserButtons />} />
          <Route path="/manage-company/:resourceId/button/:id" element={<CompanyButtons />} />
          <Route path="/manage-user/:resourceId/create-button/:id" element={<CreateUserButtons />} />
          <Route path="/manage-company/:resourceId/create-button/:id" element={<CreateCompanyButtons />} />
        </Route>

        <Route
          element={
            <Privateroute allowedRoles={["transaction_cordinator"]} />
          }
        >
          <Route path="/deals-assigned" element={<DealsAssigned />} />
        </Route>
        <Route path="*" element={<div>Page Not Found</div>} />
      </Routes>
    </>
  );
}

export default App;
